<app-spu-form-wrapper
  data-testid="ordinary-spu-edit-form-wrapper"
  [config]="config"
  [editMode]="true"
  [viewMode]="false"
  [showFaq]="true"
></app-spu-form-wrapper>
